<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <!-- OBSERVACIONES DENUNCIAS-->
      <div v-if="isFieldVisible('report_observations')" class="col-md-12 mt-3">
        <div class="col-md-6">
          <label for="report_observations" class="form-label text-left">{{ getFieldDescription('report_observations') }}</label>
          <textarea
            class="form-control" 
            id="report_observations" 
            v-model="formData.report_observations"
            @input="() => emitFieldChanged('report_observations')"
            required="required"
            maxlength="1024"
          ></textarea>
        </div>
      </div>
      <hr class="custom-hr mt-4"/>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'FormComplaintObservations',
  props: {
    data: Object,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);

    const report_observations = ref(null);

    const formData = ref({
      report_observations: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (dataCompany.value && dataCompany.value.report_observations);
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const emitFieldChanged = () => {
      emit('formDataChanged', formData.value);
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      formData,
      emitFieldChanged,
      report_observations,
    };
  },
};
</script>
